var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "lc-category" } }, [
    _c("div", { staticClass: "lc-category-setting-row row" }, [
      _c("div", { staticClass: "col-lg-6 col-sm-12 col-md-6" }, [
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            {
              staticClass:
                "col-lg-7 col-sm-12 col-md-12 mb-0 col mb-sm-2 simple-dropdown-wrapper"
            },
            [
              _c("p", { staticClass: "bodytext mb-1" }, [
                _vm._v(_vm._s(_vm.trans("lifechallenge_category")))
              ]),
              _c("SimpleDropdownComponent", {
                attrs: {
                  dataSource: _vm.categories,
                  displayProp: "name",
                  changeUrl: true
                },
                model: {
                  value: _vm.category,
                  callback: function($$v) {
                    _vm.category = $$v
                  },
                  expression: "category"
                }
              })
            ],
            1
          ),
          !_vm.voting_enabled
            ? _c(
                "div",
                {
                  staticClass:
                    "col-lg-5 col-sm-12 col-md-12 mb-0 col mb-sm-2 simple-dropdown-wrapper"
                },
                [
                  _c("p", { staticClass: "bodytext mb-1" }, [
                    _vm._v(_vm._s(_vm.trans("lifechallenge_country")))
                  ]),
                  _c("SimpleDropdownComponent", {
                    attrs: {
                      dataSource: _vm.countries,
                      displayProp: "name",
                      changeUrl: false
                    },
                    model: {
                      value: _vm.country,
                      callback: function($$v) {
                        _vm.country = $$v
                      },
                      expression: "country"
                    }
                  })
                ],
                1
              )
            : _vm._e()
        ])
      ]),
      _c("div", { staticClass: "col-lg-6 col-sm-12 col-md-6" }, [
        _vm.voting_enabled
          ? _c(
              "div",
              { staticClass: "lc-fade-voting" },
              [
                _c("span", [_vm._v(_vm._s(_vm.trans("fade_voted")))]),
                _c("ToggleComponent", {
                  model: {
                    value: _vm.fadeVoted,
                    callback: function($$v) {
                      _vm.fadeVoted = $$v
                    },
                    expression: "fadeVoted"
                  }
                })
              ],
              1
            )
          : _vm._e()
      ])
    ]),
    _c("div", { staticClass: "row lc-proj-paginator" }, [
      _c("div", { staticClass: "col-lg-6 col-sm-6 col-md-6" }, [
        _c("div", { staticClass: "lc-proj-cnt" }, [
          _vm._v(
            _vm._s(_vm.paginatedData.itemsCnt) +
              " " +
              _vm._s(_vm.trans("projects"))
          )
        ])
      ]),
      _c(
        "div",
        { staticClass: "col-lg-6 col-sm-6 col-md-6" },
        [
          _vm.paginatedData.pagesCnt > 1
            ? _c("PaginatorComponent", {
                attrs: {
                  selectedPage: _vm.paginatedData.selectedPage,
                  pagesCnt: _vm.paginatedData.pagesCnt
                },
                on: { pageSelected: _vm.pageSelected }
              })
            : _vm._e()
        ],
        1
      )
    ]),
    _c(
      "div",
      { staticClass: "lc-project-list row" },
      _vm._l(_vm.paginatedData.projectsToShow, function(project) {
        return _c("ProjectComponent", {
          key: project.id,
          attrs: { project: project, year: _vm.year, fadeVoted: _vm.fadeVoted }
        })
      }),
      1
    ),
    _c(
      "div",
      { staticClass: "lc-proj-paginator" },
      [
        _vm.paginatedData.pagesCnt > 1
          ? _c("PaginatorComponent", {
              attrs: {
                selectedPage: _vm.paginatedData.selectedPage,
                pagesCnt: _vm.paginatedData.pagesCnt
              },
              on: { pageSelected: _vm.pageSelected }
            })
          : _vm._e()
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }